import { render, staticRenderFns } from "./TimTeknisPemutakhiran.vue?vue&type=template&id=31aa5069&"
import script from "./TimTeknisPemutakhiran.vue?vue&type=script&lang=js&"
export * from "./TimTeknisPemutakhiran.vue?vue&type=script&lang=js&"
import style0 from "./TimTeknisPemutakhiran.vue?vue&type=style&index=0&id=31aa5069&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports